import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_COUPON_FREQUENCY,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_FLOOR_STRIKE,
  PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE,
  PAYOFF_PARTICIPATION_STRIKE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_REFERENCE_ENTITIES,
  SUMMARY_SETTLEMENT_TYPE,
  SUMMARY_UNDERLYING_ASSETS_GROUP,
  SUMMARY_FREQUENCY,
  PAYOFF_CALLABILITY_AMOUNT_TYPE,
  PAYOFF_CALLABILITY_AMOUNT,
} from '../../mockups/consts/product-capture-field-selectors.consts';

export const EQ_ISSUER_CALLABLE_SETTINGS = {
  id: ProductTypeEnum.EQ_ISSUER_CALLABLE,
  label: 'Issuer Callable - Equity',
  effects: [
    {
      formControlNames: [SUMMARY_REFERENCE_ENTITIES, PAYOFF_COUPON_CONVERSION],
      hidden: true,
    },
    {
      formControlNames: [
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
      ],
      selectValues: ['NONE'],
      readOnly: false,
      hidden: true,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_CALL_EVENT_TYPE],
      selectValues: ['ISSUER_CALL'],
      readOnly: true,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_AMOUNT_TYPE],
      selectValues: [null],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_CALLABILITY_AMOUNT],
      selectValues: [null],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: [COUPON_TYPE.FIXED],
      readOnly: true,
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE],
      selectValues: ['FIXED'],
      readOnly: false,
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_TYPE],
      selectValues: ['PUT'],
      hidden: false,
    },
    {
      formControlNames: [
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
        SUMMARY_UNDERLYING_ASSETS_GROUP,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE,
        PAYOFF_PARTICIPATION_FLOOR_STRIKE,
      ],
      hidden: false,
    },
    {
      formControlNames: [
        SUMMARY_FREQUENCY,
        SUMMARY_PERFORMANCE_TYPE,
        SUMMARY_SETTLEMENT_TYPE,
        PAYOFF_COUPON_FREQUENCY,
      ],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
      readOnly: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_STRIKE],
      selectValues: [
        {
          minValue: null,
          maxValue: null,
          value: null,
          indicativeValue: null,
        },
      ],
    },
  ],
};
